// extracted by mini-css-extract-plugin
export default {"moreFromMotorway":"MoreFromMotorway-module__moreFromMotorway-HbqW"};